export const nullMethod = () => ({});

export default {
  nullMethod,
};
